var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"a","d":"M13.295.705a.997.997 0 0 0-1.41 0L7.707 4.883a1 1 0 0 1-1.414 0L2.115.705a.997.997 0 1 0-1.41 1.41l4.178 4.178a1 1 0 0 1 0 1.414L.705 11.885a.997.997 0 0 0 1.41 1.41l4.178-4.178a1 1 0 0 1 1.414 0l4.178 4.178a.997.997 0 0 0 1.41-1.41L9.117 7.707a1 1 0 0 1 0-1.414l4.178-4.178a.997.997 0 0 0 0-1.41z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(5 5)","key":1},[React.createElement("mask",{"id":"b","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#a"})),React.createElement("use",{"fill":"#FFF","xlinkHref":"#a","key":1}),React.createElement("g",{"fill":"#FFF","mask":"url(#b)","key":2},React.createElement("path",{"d":"M-5-5h24v24H-5z"}))])]);
}

IconClose.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconClose;

IconClose.default = IconClose;
